import { GeneralObjectKey } from "src/modules/enaio/shared/GeneralObjectKey";
import { GeneralObjectActionProvider } from "../shared/general-object-action-provider.model";
import { Comparable } from "src/modules/utils/shared/comparable";
import { Utils } from "src/modules/utils/shared/utils";

export class TableCell implements Comparable<TableCell> {

    static getValue(value: any): any {
        return value instanceof TableCell ? value.value : value;
    }

    value: any;
    styleClass: string;
    colSpan = 1;
    keepHtml: boolean;
    internal: GeneralObjectKey[];
    actionProviders: GeneralObjectActionProvider[];

    constructor (value: any, props: Partial<TableCell> = null) {
        this.value = value;
        if (props != null) {
            Object.assign(this, props);
        }
    }

    compareTo(other: TableCell): number {
        return Utils.cmp(this.value, TableCell.getValue(other));
    }

}
